import { v1 } from './v1';

export const mediaMetadata = {
  v1,
};
